/*
 * ********************************************************************
 *  GlobePayroll Confidential
 *
 *  COPYRIGHT ©2016 by GlobePayroll. All Rights Reserved.
 *
 *   NOTICE:  All information contained herein is, and remains the property of GlobePayroll.
 *   The intellectual and technical concepts contained herein are proprietary to GlobePayroll
 *   and may be covered by U.S. and Foreign Patents, patents in process, and are protected by
 *   trade secret or copyright law.
 *   Dissemination of this information or reproduction of this material is strictly forbidden
 *   unless prior written permission is obtained from GlobePayroll.
 *  ********************************************************************
 */

import {CommonModule} from '@angular/common';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule, Routes} from '@angular/router';

import {TranslateModule} from '@ngx-translate/core';

import {BackupsComponent} from './backups/backups.component';
import {HireComponent} from './hire/hire.component';
import {MssComponent} from './mss.component';
import {MyTeamReportsComponent} from './my-team-reports/my-team-reports.component';
import {MyTeamComponent} from './my-team/my-team.component';
import {TeamPlanningComponent} from './team-planning/team-planning.component';
import {TeamPlanningModule} from './team-planning/team-planning.module';

import {MomentModule} from 'ngx-moment';
import {PdfViewerModule} from 'ng2-pdf-viewer';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {ConfigurationModule} from '../+configuration/configuration.module';
import {TimeModule} from '../+payrolls/prepare/time/time.module';
import {ReportsModule} from '../+reports/reports.module';
import {RouteGuard} from '../shared/authentication/roles/route-guard';
import {ContractDataModule} from '../shared/contract-data/contract-data.module';
import {ContractDataService} from '../shared/contract-data/contract-data.service';
import {ContractEmployeeMenuModule} from '../shared/contract-employee-menu/contract-employee-menu.module';
import {EmployeesSharedModule} from '../shared/employees/employees-shared.module';
import {FilesModule} from '../shared/files/files.module';
import {FormGeneratorModule} from '../shared/form-generator/form-generator.module';
import {HireModule} from '../shared/hire/hire.module';
import {ModalModule} from '../shared/modal/modal.module';
import {PipesModule} from '../shared/pipes/pipes.module';
import {TeamsSharedModule} from '../shared/teams/teams-shared.module';
import {UiModule} from '../shared/ui/ui.module';
import {UserModule} from '../shared/user/user.module';

const routes: Routes = [
  {
    path: '',
    component: MssComponent,
    children: [
      {
        path: 'employee-info',
        component: MyTeamComponent,
        canActivate: [RouteGuard]
      },
      {
        path: 'hire',
        component: HireComponent,
        canActivate: [RouteGuard]
      },
      {
        path: 'reports',
        component: MyTeamReportsComponent,
        canActivate: [RouteGuard]
      },
      {
        path: 'team-planning',
        component: TeamPlanningComponent,
        canActivate: [RouteGuard]
      },
      {
        path: 'backups',
        component: BackupsComponent,
        canActivate: [RouteGuard]
      }

    ]
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MomentModule,
    ModalModule,
    UiModule,
    TooltipModule,
    PipesModule,
    FilesModule,
    UserModule,
    FormGeneratorModule,
    TranslateModule,
    TabsModule.forRoot(),
    EmployeesSharedModule,
    TeamsSharedModule,
    TimeModule.forRoot(),
    RouterModule.forChild(routes),
    PdfViewerModule,
    ReportsModule,
    ContractDataModule,
    ContractEmployeeMenuModule,
    HireModule,
    ConfigurationModule,
    TeamPlanningModule,
  ],
  declarations: [
    MssComponent,
    MyTeamComponent,
    MyTeamReportsComponent,
    HireComponent,
    BackupsComponent
  ],
  exports: [
    RouterModule
  ]
})

export class MSSModule {
  public static forRoot(): ModuleWithProviders<UserModule> {
    return {
      ngModule: UserModule,
      providers: [
        ContractDataService
      ]
    };
  }
}
